import clsx from 'clsx'
import { ChevronsUpDownIcon } from 'lucide-react'
import React, { forwardRef } from 'react'

interface ProfileMenuToggleProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'className'> {
  children: React.ReactNode;
  open?: boolean;
  width?: 'full' | 'auto';
}

function ThatchLogo () {
  return (
    <svg
      aria-hidden
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='20'
      viewBox='0 0 17 20'
      fill='none'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='17'
        height='20'
        viewBox='0 0 17 20'
        fill='none'
      >
        <mask
          id='thatch-logo-mask'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='17'
          height='20'
        >
          <path
            d='M6.78404 5.57252H5.82629V20H6.78404V5.57252Z'
            fill='#C4C4C4'
          />
          <path
            d='M11.1737 5.57252H10.216V19.6947H11.1737V5.57252Z'
            fill='#C4C4C4'
          />
          <path
            d='M6.78404 5.57252H0V6.48855H6.78404L6.78404 5.57252Z'
            fill='#C4C4C4'
          />
          <path d='M17 5.57252H10.216V6.48855H17V5.57252Z' fill='#C4C4C4' />
          <path
            d='M10.6948 0.76336H0.239434V1.67939H10.6948V0.76336Z'
            fill='#C4C4C4'
          />
          <path
            d='M0.957747 0.76336H0V6.48855L0.957747 6.48855V0.76336Z'
            fill='#C4C4C4'
          />
          <path
            d='M17 1.22137H16.0423V6.48855L17 6.48855V1.22137Z'
            fill='#C4C4C4'
          />
          <path
            d='M10.216 2.44275C10.9212 2.44275 11.493 1.89592 11.493 1.22137C11.493 0.546828 10.9212 0 10.216 0C9.5107 0 8.93897 0.546828 8.93897 1.22137C8.93897 1.89592 9.5107 2.44275 10.216 2.44275Z'
            fill='#C4C4C4'
          />
          <path
            d='M10.6948 20C11.4001 20 11.9718 19.4532 11.9718 18.7786C11.9718 18.1041 11.4001 17.5573 10.6948 17.5573C9.98957 17.5573 9.41784 18.1041 9.41784 18.7786C9.41784 19.4532 9.98957 20 10.6948 20Z'
            fill='#C4C4C4'
          />
        </mask>
        <g mask='url(#thatch-logo-mask)'>
          <path d='M17 0H0V20H17V0Z' fill='url(#thatch-logo-gradient)' />
        </g>
        <defs>
          <linearGradient
            id='thatch-logo-gradient'
            x1='8.5'
            y1='0'
            x2='8.5'
            y2='20'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#230DAC' />
            <stop offset='1' stopColor='#FB09C6' />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  )
}

export const ProfileMenuToggle = forwardRef<
  HTMLButtonElement,
  ProfileMenuToggleProps
>(({ children, open = false, width = 'auto', ...props }, forwardedRef) => {
  return (
    <button
      {...props}
      className={clsx(
        'appearance-none flex items-center gap-2 rounded-lg p-2 body text-gray-800 data-[state*="open"]:bg-gray-200 outline outline-offset-2 outline-2 outline-transparent focus-visible:outline-thatch-500',
        {
          'hover:bg-gray-100 focus-visible:bg-gray-100': !open,
          'bg-gray-200': open,
          'w-full': width === 'full',
        }
      )}
      ref={forwardedRef}
      type='button'
    >
      <span className='flex-shrink-0'>
        <ThatchLogo />
      </span>
      <span className='truncate'>{children}</span>
      <span
        className={clsx('transition', {
          'text-gray-400': !open,
          'text-gray-500': open,
        })}
      >
        <ChevronsUpDownIcon aria-hidden size='16' />
      </span>
    </button>
  )
})
